import { Box, makeStyles, Typography } from '@material-ui/core';
import { useNavigate } from 'react-router';
import { EntityIcon } from '../../Entity';
import { MarketplaceSearchResultEnriched } from '../types';

const useStyles = makeStyles(theme => ({
  listItem: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    rowGap: theme.spacing(0.5),
    maxWidth: '100%',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: `${theme.palette.bkg.primary}`,
    },
  },
  contentContainer: {
    display: 'flex',
    columnGap: theme.spacing(1),
  },
  icon: {
    flexShrink: 0,
  },
  description: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    fontSize: theme.typography.body1.fontSize,
  },
  title: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    fontWeight: 700,
    fontSize: theme.typography.subtitle2.fontSize,
    color: theme.palette.primary.main,
  },
}));

export const SearchFavoriteListItem = ({
  entity,
}: {
  entity: MarketplaceSearchResultEnriched | undefined;
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  if (!entity) return null;

  const handleRedirect = () => {
    navigate(entity.document.location);
  };

  return (
    <Box className={classes.listItem} onClick={handleRedirect}>
      <Box className={classes.contentContainer}>
        <EntityIcon
          title={entity.document._nameWithVersion}
          useCaseTemplateId={entity.document.useCaseTemplateId}
          kind={entity.document._computedInfo.kind}
          className={classes.icon}
          taxonomyId={entity.document._computedInfo.taxonomy.external_id}
        />
        <Typography variant="body1" className={classes.title}>
          {entity.document._nameWithVersion}
        </Typography>
      </Box>
      <Typography variant="body1" className={classes.description}>
        {entity.document.description}
      </Typography>
    </Box>
  );
};
